<template>
  <page-wrapper :title="title" :hasPad="true">
    <draggable
      class="list"
      v-model="sorted"
      v-bind="dragOptions"
      @start="drag = true"
      @end="drag = false"
    >
      <transition-group type="transition" :name="!drag ? 'flip-list' : null">
        <div class="item" v-for="element in sorted" :key="element.id">
          <i
            :class="
              element.fixed ? 'fa fa-anchor' : 'glyphicon glyphicon-pushpin'
            "
            @click="element.fixed = !element.fixed"
            aria-hidden="true"
          ></i>
          <img class="icon" :src="element.icon" />
          {{ element.name }}
        </div>
      </transition-group>
    </draggable>
    <div class="text-right mt-4">
      <sc-button variant="primary" @click="handleClickSave">บันทึก</sc-button>
    </div>
  </page-wrapper>
</template>

<script>
import draggable from "vuedraggable";
import PageWrapper from "@/lib/components/PageWrapper";
import ScButton from "@/lib/components/ScButton";
import CategoryListItem from "../components/CategoryListItem";
import { baanRueJaiClient } from "@/dependencies";

export default {
  components: {
    draggable,
    PageWrapper,
    ScButton,
    CategoryListItem
  },
  data() {
    const title = "จัดลำดับหมวดหมู่บริการ";
    const list = [];
    const sorted = [];
    const drag = false;

    return {
      title,
      list,
      sorted,
      drag
    };
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    }
  },
  created() {
    this.setup();
  },
  methods: {
    setup() {
      this.setupData();
    },
    setupData() {
      this.setupList();
    },
    async setupList() {
      const list = await this.fetchList();

      this.list = list;
      this.sorted = list;
    },
    async fetchList() {
      const response = await baanRueJaiClient.admin.subscriptions.serviceCategories.list();

      return response.data.result;
    },
    async handleClickSave() {
      try {
        await baanRueJaiClient.admin.subscriptions.serviceCategories.putOrder({
          ids: this.sorted.map(({ id }) => id)
        });
        alert("บันทึกเรียบร้อย");
      } catch (error) {
        console.error(error);

        alert("ไม่สามารถเรียงลำดับได้");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.header {
  display: flex;
  justify-content: space-between;

  padding: 30px;
  border-bottom: $border;
}

.list {
  padding-bottom: 15px;
  overflow: auto;
}

.list > span {
  display: grid;
  grid-gap: 15px;
  grid-auto-flow: column;
  justify-content: flex-start;

  @media (max-width: 600px) {
    grid-auto-columns: 1fr;
    grid-auto-flow: row;
  }

  > .item {
    border: 1px solid #e0e0e0;
    background: #fafafa;
    width: 100px;
    height: 100px;

    @media (max-width: 600px) {
      width: auto;
      height: auto;
    }
  }
}

.item {
  padding: 10px;

  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;

  font-size: 14px;

  cursor: pointer;

  @media (max-width: 600px) {
    flex-flow: row;
    justify-content: flex-start;
    padding: 5px 10px;
  }

  > .icon {
    margin-bottom: 5px;
    width: 48px;
    height: 48px;

    @media (max-width: 600px) {
      margin-bottom: 0;
      margin-right: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/features/subscriptions/modules/service-categories/pages/ServiceCategorySortPage.vue